export default __webpack_public_path__ + "static/14224-01-e62dff4faecf6616e719e8090981e23a.webp";